define('areas/home/viewmodels/shellextender',["require", "exports", "areas/home/model/panels", "services/settings", "durandal/app", "models/account", "services/httpclient"], function (require, exports, Panels, Configuration, App, Account, HttpClient) {
    "use strict";
    var ShellExtender = (function () {
        function ShellExtender(shell) {
            var that = this;
            this._shell = shell;
            App.off("authentication", that.onAuthenticationChanged, that);
            App.on("authentication", that.onAuthenticationChanged, that);
            App.on("appcues", that.startAppcues, that);
            App.on("customcss", that.getCustomCss, that);
        }
        ShellExtender.prototype.initialize = function () {
            var _this = this;
            var leftPanels = Enumerable.From(Configuration.Settings.environment.leftPanels);
            leftPanels.ForEach(function (pnl) {
                _this._shell.leftPanels.push(new Panels.ShellPanel(Panels.PanelType.ComposedView, pnl.path, pnl.isVisible != null ? pnl.isVisible : true));
            });
            var rightPanels = Enumerable.From(Configuration.Settings.environment.rightPanels);
            rightPanels.ForEach(function (pnl) {
                _this._shell.rightPanels.push(new Panels.ShellPanel(Panels.PanelType.ComposedView, pnl.path));
            });
            if (rightPanels.Count() > 0)
                ko.getObservable(this._shell, "viewType").subscribe(this.onViewTypeChanged, this);
            /*route maps*/
            this._shell.router.map({ route: "logout", moduleId: "logout/viewmodels/index", title: "Logout", nav: false });
            this._shell.router.map({ route: "informationrequest/clientDetails", moduleId: "informationrequest/viewmodels/clientDetails", title: "Details", nav: false });
            this._shell.router.map({ route: "digitaldatareview/clientDetails", moduleId: "informationrequest/viewmodels/clientDetails", title: "Details", nav: false });
            this._shell.router.map({ route: "digitaltax/clientDetails", moduleId: "informationrequest/viewmodels/clientDetails", title: "Details", nav: false });
            this._shell.router.map({ route: "informationrequest/hmrcInfoDetails", moduleId: "informationrequest/viewmodels/hmrcInfoDetails", title: "Details", nav: false });
            this._shell.router.map({ route: "digitaltax/hmrcInfoDetails", moduleId: "informationrequest/viewmodels/hmrcInfoDetails", title: "Details", nav: false });
            this._shell.router.map({ route: "tools/wkappstore", moduleId: "wkappstore/viewmodels/index", title: "WKAppStore", nav: false });
            this._shell.router.map({ route: "i-Serve", moduleId: "iServe/viewmodels/index", title: "i-Serve", nav: false });
            this._shell.router.map({ route: "tools/i-Serve/true", moduleId: "iServe/viewmodels/index", title: "i-Serve", nav: false });
            this._shell.router.map({ route: "open-integration", moduleId: "wkappstore/viewmodels/index", title: "open-integration", nav: false });
            this._shell.router.map({ route: "messages-documents", moduleId: "wkappstore/viewmodels/index", title: "messages-documents", nav: false });
        };
        ShellExtender.prototype.onViewTypeChanged = function (newValue) {
            switch (newValue) {
                case "UserType":
                    this._shell.rightPanels[0].visible = true;
                    break;
                default:
                    this._shell.rightPanels[0].visible = false;
                    break;
            }
        };
        ShellExtender.prototype.onAuthenticationChanged = function () {
            var _this = this;
            if (Account.Session.isAuthenticated) {
                var initializers = Configuration.Settings.environment.initializers;
                if (initializers != null) {
                    Enumerable.From(initializers).ForEach(function (initializer) {
                        if (initializer.memberType == null || initializer.memberType === Account.Session.principal.memberType) {
                            switch (initializer.type) {
                                case "Dialog":
                                    {
                                        if (initializer.oneTimeOnly === false)
                                            App.showDialog(initializer.path);
                                        else {
                                            _this._shell.userManager.getSettings(initializer.key)
                                                .then(function (data) {
                                                if (data === "") {
                                                    App.showDialog(initializer.path);
                                                }
                                            });
                                        }
                                        break;
                                    }
                                case "Notification":
                                    {
                                        if (initializer.oneTimeOnly && Configuration.Settings.environment.userManager.type === 'trippleA') {
                                            _this._shell.userManager.getSettings(initializer.key)
                                                .then(function (data) {
                                                if (data === "") {
                                                    _this.getAAAFlags()
                                                        .then(function (aaaConfiguration) {
                                                        if (aaaConfiguration.isAAAEnabled) {
                                                            _this.createClientPortalNotification(Account.Session.principal.identityId)
                                                                .then(function (data) {
                                                                _this._shell.userManager.saveSettings(initializer.key, { executed: true });
                                                            })
                                                                .fail(function (error) {
                                                                console.log(error.responseText);
                                                            });
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                        break;
                                    }
                            }
                        }
                    });
                }
            }
        };
        ShellExtender.prototype.startAppcues = function () {
            if (Appcues && (Account.Principal.current.memberType === 'stb_postmaster' || Account.Principal.current.memberType === 'stb_admin' || Account.Principal.current.memberType === 'client_postmaster')) {
                this._widget = null;
                Appcues.identify(Account.Principal.current.identityId, {
                    userType: Account.Principal.current.memberType
                });
            }
        };
        ShellExtender.prototype.getCustomCss = function () {
            if (Account.Principal.current.memberType === "client_postmaster")
                // adding custom theme
                $('head').append('<link rel="stylesheet" href="' + Configuration.Settings.getPublicApiFor("api/configuration/subdomains/" + Configuration.Settings.getPortalDomain() + "/theme/css") + '"  />');
        };
        ShellExtender.prototype.startAppcuesWidget = function () {
            if (this._widget == null) {
                this._widget = AppcuesWidget(Appcues.user());
                this._widget.init("#ac-widget", {
                    position: "left"
                });
            }
        };
        ShellExtender.prototype.createClientPortalNotification = function (userIdentityId) {
            var service = new HttpClient.Channel();
            return service.postDataAsync("users/" + userIdentityId + "/activationcompleted", HttpClient.ServiceTarget.clientPortalApi, null);
        };
        ShellExtender.prototype.getAAAFlags = function () {
            var service = new HttpClient.Channel();
            return service.getDataAsync("/activation/api/aaamigration/aaaflags/subdomain/" + Configuration.Settings.getPortalDomain(), HttpClient.ServiceTarget.oneClickServiceApi)
                .then(function (data) {
                return data;
            })
                .fail(function (error) {
                return error;
            });
            ;
        };
        return ShellExtender;
    }());
    return ShellExtender;
});

